export const state = () => ({
	student_profile: null,
	partner_universities: null,
	additional_universities: [],
	adding_university: false,
});

export const mutations = {
	setStudentProfile(state: any, payload: any) {
		state.student_profile = payload;
	},
	setPartnerUniversities(state: any, payload: any) {
		state.partner_universities = payload;
	},
	setAdditionalUniversities(state: any, payload: any) {
		state.additional_universities = payload;
	},
	setAddingUniversity(state: any, payload: any) {
		state.adding_university = payload;
	},
};

export const getters = {
	getStudentProfile: (state: any) => state.student_profile,
	getPartnerUniversities: (state: any) => state.partner_universities,
	getAdditionalUniversities: (state: any) => state.additional_universities,
	getAddingUniversity: (state: any) => state.adding_university,
};

export const actions = {
	async getPartnerUniversities(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/partners')
				.then((res) => {
					state.commit('setPartnerUniversities', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateProfileAddress(state: any, payload: any) {
		const address = { address: { ...payload } };

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/profile/address', address)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateUserInformation(state: any, payload: any) {
		let user = {
			name: this.$auth.user.name,
			surname: this.$auth.user.surname,
			phone: this.$auth.user.phone,
			dob: payload.dob,
			id_number: payload.id_number,
			email: this.$auth.user.email,
		};

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/user/information', user)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async toggleLookingForWork(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/looking-for-work', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async toggleShareContactInfo(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/share-contact-info-with-employer', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateStudentProfile(state: any, payload: any) {
		state.commit('setStudentProfile', payload);
	},
	updateAdditionalUniversities(state: any, payload: any) {
		state.commit('setAdditionalUniversities', payload);
	},
	updateAddingUniversity(state: any, payload: any) {
		state.commit('setAddingUniversity', payload);
	},
};
